<template>
    <div class="md:bg-transparent bg-white container px-5 md:py-0 py-6 mx-auto flex flex-grow">
        <div class="grid grid-cols-12 items-center h-auto flex-grow">
            <div
                class="md:col-span-6 col-span-12 md:bg-white -my-6 xl:px-28 lg:px-18 md:px-8 sm:px-14 px-5 md:mx-0 -mx-5 lg:py-16 md:py-10 sm:py-4 py-4 md:h-full md:flex md:items-center"
            >
                <div class="w-full">
                    <h3 class="leading-8">Registro de usuarios nuevos</h3>
                    <div class="mt-8" v-if="selectedPlan">
                        <label class="text-gray-500">Plan elegido</label>
                        <div id="plan-info" class="border border-blue-500 rounded-lg relative py-3 px-6 mt-2">
                            <p id="plan-name" class="font-bold">{{ selectedPlan.name }}</p>
                            <a
                                href="#"
                                @click.prevent="planModalIsClosed = false"
                                class="absolute top-0 right-0 py-3 px-6 text-xs text-blue-500 hover:text-blue-700 duration-300 ease-in-out"
                                >Cambiar plan</a
                            >
                            <h2>
                                {{ selectedPlan.presentable_pricing }}
                                <small class="font-normal">{{ selectedPlan.currency }}</small>
                            </h2>
                            <p class="text-sm">Fin de la prueba: {{ selectedPlan.presentable_trial_ends_at }}</p>
                        </div>
                    </div>
                    <form
                        class="mt-8"
                        id="register-form"
                        @keydown="form.errors.clear($event.target.name)"
                    >
                        <div>
                            <label class="text-gray-500" for="first_name">Nombre(s)</label>
                            <input
                                id="first-name"
                                type="text"
                                name="first_name"
                                v-model="form.first_name"
                                class="block w-full py-3 mt-2 leading-5 transition duration-150 ease-in-out rounded form-input bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                placeholder="Escribe tu nombre(s)"
                                required
                            />
                            <span
                                id="firt-name-errors"
                                v-if="form.errors.has('first_name')"
                                v-text="form.errors.get('first_name')"
                                class="text-red-500 text-sm"
                            ></span>
                        </div>
                        <div class="mt-4">
                            <label class="text-gray-500" for="last_name">Apellidos</label>
                            <input
                                id="last-name"
                                type="text"
                                name="last_name"
                                v-model="form.last_name"
                                class="block w-full py-3 mt-2 leading-5 transition duration-150 ease-in-out rounded form-input bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                placeholder="Escribe tus apellidos"
                                required
                            />
                            <span
                                id="last-name-errors"
                                v-if="form.errors.has('last_name')"
                                v-text="form.errors.get('last_name')"
                                class="text-red-500 text-sm"
                            ></span>
                        </div>
                        <div class="mt-4">
                            <label class="text-gray-500" for="email">Correo electrónico</label>
                            <input
                                id="email"
                                type="email"
                                name="email"
                                v-model="form.email"
                                class="block w-full py-3 mt-2 leading-5 transition duration-150 ease-in-out rounded form-input bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                placeholder="Escribe tu correo electrónico"
                                required
                            />
                            <span
                                id="email-errors"
                                v-if="form.errors.has('email')"
                                v-text="form.errors.get('email')"
                                class="text-red-500 text-sm"
                            ></span>
                        </div>
                        <div class="mt-4">
                            <label class="text-gray-500" for="password">Crea tu contraseña</label>
                            <password-toggle>
                                <input
                                    id="password"
                                    type="password"
                                    name="password"
                                    @input="fillPassword($event.target.value)"
                                    :value="form.password"
                                    class="block w-full py-3 mt-2 leading-5 transition duration-150 ease-in-out rounded form-input pr-11 bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                    placeholder="Escribe tu contraseña"
                                    required
                                />
                            </password-toggle>
                            <div class="mt-2">
                                <div
                                    class="password-check grid xl:grid-cols-5 md:grid-cols-1 sm:grid-cols-5 grid-cols-1 gap-x-3 gap-y-1 text-gray-400"
                                >
                                    <div
                                        id="password-is-upper-and-lowercase"
                                        class="xl:col-span-3 md:col-span-1 sm:col-span-3 col-span-1"
                                        :class="{
                                            passed: passwordValidator.isUpperAndLowercase,
                                            error: form.password.length > 0 && !passwordValidator.isUpperAndLowercase,
                                        }"
                                    >
                                        <span class="text-sm">● Una mayúscula y una minúscula</span>
                                    </div>
                                    <div
                                        id="password-has-a-number"
                                        class="xl:col-span-2 md:col-span-1 sm:col-span-2 col-span-1"
                                        :class="{
                                            passed: passwordValidator.hasANumber,
                                            error: form.password.length > 0 && !passwordValidator.hasANumber,
                                        }"
                                    >
                                        <span class="text-sm">● Un número</span>
                                    </div>
                                    <div
                                        id="password-is-long-enough"
                                        class="xl:col-span-3 md:col-span-1 sm:col-span-3 col-span-1"
                                        :class="{
                                            passed: passwordValidator.isLongEnough,
                                            error: form.password.length > 0 && !passwordValidator.isLongEnough,
                                        }"
                                    >
                                        <span class="text-sm">● Mínimo 8 caracteres</span>
                                    </div>
                                    <div
                                        id="password-has-a-symbol"
                                        class="xl:col-span-2 md:col-span-1 sm:col-span-2 col-span-1"
                                        :class="{
                                            passed: passwordValidator.hasASymbol,
                                            error: form.password.length > 0 && !passwordValidator.hasASymbol,
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <label class="text-gray-500" for="phone">Teléfono</label>
                            <input
                                id="phone"
                                type="tel"
                                name="phone"
                                v-model="form.phone"
                                class="input-number block w-full py-3 mt-2 leading-5 transition duration-150 ease-in-out rounded form-input bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                placeholder="Escribe tu teléfono"
                                maxlength="10"
                                required
                            />
                            <span
                                id="phone-errors"
                                v-if="form.errors.has('phone')"
                                v-text="form.errors.get('phone')"
                                class="text-red-500 text-sm"
                            ></span>
                        </div>
                        <div class="mt-4">
                            <label class="text-gray-500">Fecha de nacimiento</label>
                            <div class="grid grid-cols-11 xl:gap-5 lg:gap-3 md:gap-1 sm:gap-5 gap-1 mt-2">
                                <div class="col-span-3">
                                    <input
                                        type="number"
                                        id="day"
                                        name="day"
                                        v-model="form.day"
                                        class="input-number input-days block w-full py-3 leading-5 transition duration-150 ease-in-out rounded form-input bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                        placeholder="Día"
                                        maxlength="2"
                                        min="1"
                                        max="31"
                                        required
                                    />
                                </div>
                                <div class="col-span-5">
                                    <select
                                        id="month"
                                        name="month"
                                        @change="changeInput($event.target.value, 'month')"
                                        :value="form.month"
                                        class="block w-full py-3 leading-5 transition duration-150 ease-in-out rounded form-select bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                        required
                                    >
                                        <option value="" disabled selected>Mes</option>
                                        <option
                                            :id="month"
                                            v-for="(month, index) in months"
                                            :value="index + 1"
                                            v-text="month"
                                        ></option>
                                    </select>
                                </div>
                                <div class="col-span-3">
                                    <select
                                        id="year"
                                        name="year"
                                        @change="changeInput($event.target.value, 'year')"
                                        :value="form.year"
                                        class="block w-full py-3 leading-5 transition duration-150 ease-in-out rounded form-select bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm"
                                        required
                                    >
                                        <option value="" disabled selected>Año</option>
                                        <option
                                            v-for="age in adultHumanLifeSpanMaximum"
                                            :value="currentYear - 17 - age"
                                            v-text="currentYear - 17 - age"
                                        ></option>
                                    </select>
                                </div>
                            </div>
                            <p class="text-gray-400 text-sm mt-1">Solo mayores de edad</p>
                            <span
                                id="birthdate-errors"
                                v-if="form.errors.has('birthdate')"
                                v-text="form.errors.get('birthdate')"
                                class="text-red-500 text-sm"
                            ></span>
                        </div>
                        <div>
                            <div class="relative flex items-start mt-8">
                                <div class="flex items-center h-5">
                                    <input
                                        id="terms-accepted"
                                        name="terms_accepted"
                                        @change="changeInput(!form.terms_accepted, 'terms_accepted')"
                                        :value="form.terms_accepted"
                                        type="checkbox"
                                        class="w-4 h-4 text-red-500 transition duration-150 ease-in-out form-checkbox focus:shadow-none"
                                    />
                                </div>
                                <div class="ml-3 text-sm leading-5">
                                    <label for="terms-accepted" class="text-gray-500"
                                        >Al finalizar aceptas
                                        <a
                                            href="/legales/terminos-y-condiciones"
                                            class="text-teal-500 transition duration-300 ease-in-out outline-none hover:text-teal-700"
                                            >Términos y condiciones</a
                                        >
                                        y
                                        <a
                                            href="/legales/aviso-de-privacidad"
                                            class="text-teal-500 transition duration-300 ease-in-out outline-none hover:text-teal-700"
                                            >Aviso de privacidad</a
                                        >
                                        de Círculo Plus.</label
                                    >
                                </div>
                            </div>
                            <span
                                id="terms-accepted-errors"
                                v-if="form.errors.has('terms_accepted')"
                                v-text="form.errors.get('terms_accepted')"
                                class="text-red-500 text-sm"
                            ></span>
                        </div>
                        <vue-recaptcha ref="invisibleRecaptcha" size="invisible" :sitekey="sitekey"> </vue-recaptcha>
                        <span
                            id="register-button"
                            type="submit"
                            class="btn btn-red block w-full px-10 py-2 mt-6 disabled"
                        >
                            Crear cuenta
                        </span>
                    </form>
                    <p class="text-sm font-semibold mt-5">
                        Ya tengo cuenta
                        <a
                            href="/login"
                            class="text-blue-500 transition duration-300 ease-in-out outline-none hover:text-blue-700"
                            >Iniciar sesión</a
                        >
                    </p>
                </div>
            </div>
            <div class="col-span-6 md:block hidden">
                <div class="xl:w-3/4 md:w-4/5 mx-auto py-6">
                    <h2 class="text-teal-500 font-bold text-center lg:text-4xl md:text-2xl">
                        Todos los beneficios exclusivos para ti.
                    </h2>
                    <img src="/images/register.png" class="w-full mt-10" alt="Imagen de registro" />
                    <p class="text-teal-500 xl:px-10 lg:px-7 mt-8">
                        Suscríbete a <strong>Círculo Plus</strong> y recibe descuentos exclusivos en los mejores
                        productos.
                    </p>
                </div>
            </div>
        </div>
        <register-plan-modal v-if="!planModalIsClosed" @bubbleUpSelectedPlan="planWasSelected"></register-plan-modal>
    </div>
</template>

<script>
import Form from '../support/Form';
import PasswordValidator from '../support/PasswordValidator';
import PasswordToggle from './PasswordToggle';
import RegisterPlanModal from './RegisterPlanModal';
import moment from 'moment';
import sweetAlert from 'sweetalert2';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
    props: ['plan'],

    data: () => ({
        form: new Form({
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            day: '',
            month: '',
            year: '',
            birthdate: '',
            phone: '',
            terms_accepted: false,
            plan: null,
            plan_id: null,
        }),
        adultHumanLifeSpanMaximum: 110,
        currentYear: moment().year(),
        planModalIsClosed: true,
        months: moment.months(),
        passwordValidator: new PasswordValidator(),
        formHasBeenVerified: false,
        sitekey: process.env.MIX_RECAPTCHA_SITE_KEY,
    }),
    components: {
        PasswordToggle,
        RegisterPlanModal,
        VueRecaptcha,
    },
    computed: {
        inputsAreFilled() {
            if (!this.form.first_name) {
                return false;
            }

            if (!this.form.last_name) {
                return false;
            }

            if (!this.form.email) {
                return false;
            }

            if (!this.form.password) {
                return false;
            }

            if (!this.form.day) {
                return false;
            }

            if (!this.form.month) {
                return false;
            }

            if (!this.form.year) {
                return false;
            }

            if (!this.form.phone) {
                return false;
            }

            if (!this.form.terms_accepted) {
                return false;
            }

            return true;
        },

        selectedPlan() {
            return this.form.plan ?? this.plan;
        },
    },

    methods: {
        closeModal() {
            $('body, html').removeClass('overflow-hidden');
            this.planModalIsClosed = true;
        },

        changeInput(value, key) {
            this.form[`${key}`] = value;
        },

        disableButton() {
            if (this.loading) {
                return true;
            }

            if (!this.inputsAreFilled) {
                return true;
            }

            return false;
        },

        fillPassword(password) {
            this.form.password = password;
            this.passwordValidator.run(this.form.password);
        },

        planWasSelected(plan) {
            this.form.plan = plan;
            this.closeModal();

            if (this.formHasBeenVerified) {
                this.loading = true;
                this.register();
            }
        },

        register() {
            (this.form.birthdate = this.form.year + '-' + this.form.month + '-' + this.form.day),
                (this.form.plan_id = this.selectedPlan.id);

            if (!this.form.plan_id) {
                return this.form.post('/registro').catch((error) => {
                    this.loading = false;
                    if (Object.keys(error.errors).length > 1) {
                        this.$refs.invisibleRecaptcha.reset();
                        return sweetAlert.fire('Error', 'Verifica tus datos.', 'error');
                    }

                    this.$refs.invisibleRecaptcha.reset();
                    (this.formHasBeenVerified = true), (this.planModalIsClosed = false);
                });
            }

            this.$refs.invisibleRecaptcha.execute();
            this.form
                .post('/registro')
                .then((response) => {
                    window.location.href = '/suscripcion';
                })
                .catch((error) => {
                    this.loading = false;
                    sweetAlert.fire('Error', 'Verifica tus datos.', 'error');
                    this.$refs.invisibleRecaptcha.reset();
                });
        },
    },
};
</script>
